function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".logo_40th_black_svg__st4{fill:#1a1a1a}.logo_40th_black_svg__st6{fill:#555}");

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_40th_black_svg__SVGID_1_",
  gradientUnits: "userSpaceOnUse",
  x1: 113.445,
  y1: 6.859,
  x2: 72.713,
  y2: 30.62
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#eadc79"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.078,
  stopColor: "#e6d46f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.206,
  stopColor: "#d9be56"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303,
  stopColor: "#cdab40"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.311,
  stopColor: "#cca93f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.504,
  stopColor: "#af8830"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.688,
  stopColor: "#9b7229"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.858,
  stopColor: "#906526"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8c6125"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_40th_black_svg__SVGID_1_)",
  d: "M121.12 2.27L85.6 3.7 83 22.58l37.62-.5-7.47-9.96z"
});

var _ref4 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_40th_black_svg__SVGID_2_",
  gradientUnits: "userSpaceOnUse",
  x1: 91.336,
  y1: 14.504,
  x2: 118.844,
  y2: 3.773,
  gradientTransform: "translate(-1.238 1.238)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#eadc79"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.078,
  stopColor: "#e6d46f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.206,
  stopColor: "#d9be56"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303,
  stopColor: "#cdab40"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.311,
  stopColor: "#cca93f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.504,
  stopColor: "#af8830"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.688,
  stopColor: "#9b7229"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.858,
  stopColor: "#906526"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8c6125"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M97.01 18.52c-1.55.03-2.65-.47-3.29-1.51-.64-1.03-.85-2.42-.63-4.17.22-1.75.78-3.15 1.69-4.21.9-1.06 2.13-1.6 3.69-1.63 1.55-.03 2.65.47 3.29 1.51.64 1.03.85 2.42.63 4.17-.22 1.75-.78 3.15-1.69 4.21-.9 1.06-2.13 1.6-3.69 1.63zm-.59-8.41c-.44.69-.73 1.59-.87 2.7s-.08 2.01.19 2.68c.27.67.78 1 1.53.99.75-.01 1.34-.36 1.78-1.05.44-.69.73-1.59.87-2.7s.08-2.01-.19-2.68c-.27-.67-.78-1-1.53-.99-.74.01-1.34.36-1.78 1.05z",
  fill: "url(#logo_40th_black_svg__SVGID_2_)"
});

var _ref6 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_40th_black_svg__SVGID_3_",
  gradientUnits: "userSpaceOnUse",
  x1: 91.293,
  y1: 14.395,
  x2: 118.801,
  y2: 3.664,
  gradientTransform: "translate(-1.238 1.238)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#eadc79"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.078,
  stopColor: "#e6d46f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.206,
  stopColor: "#d9be56"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303,
  stopColor: "#cdab40"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.311,
  stopColor: "#cca93f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.504,
  stopColor: "#af8830"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.688,
  stopColor: "#9b7229"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.858,
  stopColor: "#906526"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8c6125"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M105.61 8.96l-.28 2.24c-.02.19.01.34.09.45.09.11.2.16.34.16.26 0 .5-.13.71-.36l.4.97c-.49.4-.97.61-1.46.62-.48.01-.87-.14-1.17-.45-.29-.31-.41-.74-.34-1.28l.29-2.3-.59-.01.13-1 .59-.01.19-1.49 1.42-.03-.19 1.49 1.22-.02-.13 1-1.22.02z",
  fill: "url(#logo_40th_black_svg__SVGID_3_)"
});

var _ref8 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_40th_black_svg__SVGID_4_",
  gradientUnits: "userSpaceOnUse",
  x1: 91.835,
  y1: 15.784,
  x2: 119.343,
  y2: 5.053,
  gradientTransform: "translate(-1.238 1.238)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#eadc79"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.078,
  stopColor: "#e6d46f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.206,
  stopColor: "#d9be56"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303,
  stopColor: "#cdab40"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.311,
  stopColor: "#cca93f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.504,
  stopColor: "#af8830"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.688,
  stopColor: "#9b7229"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.858,
  stopColor: "#906526"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8c6125"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M109.02 10.2l-.34 2.69-1.41.03.87-6.89 1.41-.03-.31 2.45c.48-.43.98-.66 1.51-.67.53-.01.95.17 1.27.53.32.37.43.86.36 1.48l-.38 3.04-1.41.03.34-2.73c.1-.77-.14-1.15-.71-1.14-.28.01-.54.11-.77.31-.24.21-.38.51-.43.9z",
  fill: "url(#logo_40th_black_svg__SVGID_4_)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "logo_40th_black_svg__st4",
  d: "M97.3 18.24c-1.55.03-2.65-.47-3.29-1.51-.64-1.03-.85-2.42-.63-4.17.22-1.75.78-3.15 1.69-4.21.9-1.06 2.13-1.6 3.69-1.63 1.55-.03 2.65.47 3.29 1.51.64 1.03.85 2.42.63 4.17-.22 1.75-.78 3.15-1.69 4.21-.91 1.05-2.14 1.6-3.69 1.63zm-.59-8.42c-.44.69-.73 1.59-.87 2.7s-.08 2.01.19 2.68c.27.67.78 1 1.53.99.75-.01 1.34-.36 1.78-1.05.44-.69.73-1.59.87-2.7s.08-2.01-.19-2.68c-.27-.67-.78-1-1.53-.99-.75.02-1.34.37-1.78 1.05zM105.89 8.68l-.28 2.24c-.02.19.01.34.09.45.09.11.2.16.34.16.26 0 .5-.13.71-.36l.4.97c-.49.4-.97.61-1.46.62-.48.01-.87-.14-1.17-.45-.29-.31-.41-.74-.34-1.28l.29-2.3-.59.01.13-1 .59-.01.19-1.49 1.42-.03-.19 1.49 1.22-.02-.13 1h-1.22zM109.3 9.92l-.34 2.69-1.41.03.87-6.89 1.41-.03-.31 2.45c.48-.43.98-.66 1.51-.67.53-.01.95.17 1.27.53.32.37.43.86.36 1.48l-.38 3.04-1.41.03.34-2.73c.1-.77-.14-1.15-.71-1.14-.28.01-.54.11-.77.31-.24.21-.38.51-.43.9z"
});

var _ref11 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_40th_black_svg__SVGID_5_",
  gradientUnits: "userSpaceOnUse",
  x1: 86.81,
  y1: 14.514,
  x2: 109.196,
  y2: 5.781,
  gradientTransform: "translate(-.345 .345)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#eadc79"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.078,
  stopColor: "#e6d46f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.206,
  stopColor: "#d9be56"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303,
  stopColor: "#cdab40"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.311,
  stopColor: "#cca93f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.504,
  stopColor: "#af8830"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.688,
  stopColor: "#9b7229"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.858,
  stopColor: "#906526"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8c6125"
}));

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M89.76 13.97l.27-2.11 2.62-.05-.27 2.11 1.38-.02-.29 2.33-1.38.02-.36 2.89-2.62.05.36-2.89-4.9.09.26-2.06 5.24-7.22 2.96-.05-5 6.93 1.73-.02z",
  fill: "url(#logo_40th_black_svg__SVGID_5_)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "logo_40th_black_svg__st4",
  d: "M90.23 13.64l.27-2.11 2.62-.05-.27 2.11 1.38-.02-.29 2.33-1.38.02-.36 2.89-2.62.05.36-2.89-4.9.09.26-2.06 5.24-7.22 2.96-.05-5 6.93 1.73-.02z"
});

var _ref14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "logo_40th_black_svg__st6",
  d: "M74.22 26.59c-.66-1.77-1.59-3.41-2.75-4.86h-5.15c.89 1.52 1.58 3.14 2.05 4.86h5.85zM57.93 14.93v5.77h6.2c-1.62-2.22-3.71-4.16-6.19-5.77h-.01zM60.52 15.19c2.05 1.59 3.8 3.44 5.17 5.51h4.92a17.95 17.95 0 00-10.09-5.51zM67.85 32.23c0-1.61-.18-3.14-.53-4.61h-4.8l5.33 4.61z"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo_40th_black_svg__st6",
  d: "M57.42 12.36c11.11 0 20.14 8.84 20.47 19.87h5.12c-.33-13.86-11.65-25-25.59-25S32.16 18.37 31.83 32.22h5.12c.33-11.02 9.36-19.86 20.47-19.86zM77.81 34.79c-.98 10.4-9.73 18.54-20.39 18.54s-19.41-8.14-20.39-18.54h-5.14c1 13.23 12.04 23.66 25.53 23.66 13.49 0 24.53-10.43 25.53-23.66h-5.14z"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo_40th_black_svg__st6",
  d: "M40.62 26.59h5.84c.47-1.72 1.17-3.35 2.05-4.86h-5.15a17.876 17.876 0 00-2.74 4.86zM39.51 32.23h6.2c0-1.6.17-3.14.49-4.61h-5.93c-.45 1.47-.71 3.01-.76 4.61z"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo_40th_black_svg__st6",
  d: "M57.42 50.77c9.24 0 16.85-6.99 17.82-15.98H66.9l-9.47-8.2-9.48 8.2H39.6c.97 8.98 8.58 15.98 17.82 15.98zM57.93 23.65l3.4 2.94h5.72c-.51-1.73-1.26-3.36-2.22-4.86h-6.9v1.92zM44.23 20.7h4.92c1.38-2.08 3.12-3.93 5.17-5.51a17.95 17.95 0 00-10.09 5.51z"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo_40th_black_svg__st6",
  d: "M74.57 27.62h-5.93c.32 1.47.5 3.01.49 4.61h6.2c-.05-1.6-.31-3.14-.76-4.61zM46.99 32.23l5.33-4.61h-4.8c-.35 1.47-.53 3-.53 4.61zM56.91 14.93s-.01 0 0 0c-2.49 1.61-4.59 3.55-6.2 5.77h6.2v-5.77zM56.91 23.65v-1.92h-6.9c-.96 1.5-1.71 3.13-2.22 4.86h5.71l3.41-2.94z"
}));

var _ref15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "logo_40th_black_svg__st6",
  d: "M98.05 46.51l6.86-25.61h6.83l.46-1.71H98.54l-2.06 7.68h-7.65l.33.43h7.21l-5.15 19.22c-.76 2.82-3.67 5.11-6.49 5.11h-5.12l-.46 1.71h10.24c3.77-.01 7.65-3.07 8.66-6.83z"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo_40th_black_svg__st6",
  d: "M96.83 19.18H90l-1.83 6.83H95zM112.85 20.04l-.46 1.71h-6.83l-6.69 24.98c-1.1 4.11-5.36 7.46-9.48 7.46H79.8l.33.43h9.26c4.3 0 8.74-3.49 9.89-7.77l6.61-24.67h6.83l.46-1.71-.33-.43z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "logo_40th_black_svg__st6",
  d: "M19.76 46.51l6.86-25.62h3.41l.46-1.71H20.25l-4 14.94h-.34c-.82 0-1.48-.24-1.96-.71-.46-.45-.69-1.06-.7-1.8 0-.32.05-.65.37-1.84l2.49-9.3-.33-.43-2.62 9.77c-.29 1.09-.34 1.46-.34 1.8 0 .89.31 1.6.82 2.11.52.5 1.26.83 2.26.83h.23l-.23.85c-2.83 0-4.51-2.29-3.75-5.12l2.97-11.1H4.89l-.46 1.71h3.41l-.23.85H5.08l.33.43H7.5l-2.17 8.11c-1.01 3.77 1.23 6.83 5 6.83h5.12l-.23.85h-4.89c-1.04 0-2-.21-2.84-.6 1.05.67 2.32 1.03 3.73 1.03h3.89l-2.17 8.11c-.76 2.83-3.67 5.12-6.49 5.12H1.32l-.46 1.71H11.1c3.77 0 7.65-3.06 8.66-6.82z"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo_40th_black_svg__st6",
  d: "M31.48 20.46l-.33-.43-.46 1.71h-3.41l-6.69 24.98c-1.11 4.11-5.36 7.45-9.48 7.45H1.52l.33.43h9.26c4.3 0 8.74-3.49 9.89-7.77l6.61-24.67h3.41l.46-1.7z"
})));

function SvgLogo40ThBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_40th_black_svg__\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 121 60",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}

export default __webpack_public_path__ + "./assets/logo_40th_black__580cdb943a0460c32296262aee3123dd.svg";
export { SvgLogo40ThBlack as ReactComponent };